import loadable from '@loadable/component';

export const UserDashboardSubLayoutLoadable = loadable(
  () => import('./UserDashboardSubLayout'),
  { resolveComponent: (module) => module.UserDashboardSubLayout },
);
